import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import type { SortState } from '../../lib/sort';

interface Props {
  label: ReactNode;
  sortKey: string;
  sort: SortState;
  onToggle: (key: string) => void;
  className?: string;
  align?: 'left' | 'right' | 'center';
  /** Rendered beside the sort button rather than inside it — e.g. an InfoTip, which is itself a button. */
  extra?: ReactNode;
}

export function SortableHeader({
  label,
  sortKey,
  sort,
  onToggle,
  className,
  align = 'left',
  extra,
}: Props) {
  const active = sort.key === sortKey && sort.direction !== null;
  const alignClass =
    align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';

  return (
    <th className={cn('px-4 py-3 font-medium select-none', className)}>
      <span className={cn('flex items-center gap-1', alignClass)}>
        <button
          type="button"
          onClick={() => onToggle(sortKey)}
          className={cn(
            'inline-flex items-center gap-1 text-left text-muted-foreground hover:text-foreground transition-colors',
            alignClass,
            active && 'text-foreground',
          )}
        >
          <span>{label}</span>
          {active && sort.direction === 'asc' && <ChevronUp className="h-3.5 w-3.5" />}
          {active && sort.direction === 'desc' && <ChevronDown className="h-3.5 w-3.5" />}
          {!active && <ChevronsUpDown className="h-3.5 w-3.5 opacity-40" />}
        </button>
        {extra}
      </span>
    </th>
  );
}
